import { params, const_var} from './reducer';
import * as cuComponent from './componentReducer';

export const controls = {
    isCheckActiveTab:'builtSize'
}
export const eventState= {
    controls:controls,
    showGallery: false
}
const eventReducer = (state = eventState, action) => {
        const newState = { ...state };
        switch (action.type) {
        case "handleAccordionTab":  

            let newCont
            var sections = document.querySelectorAll('.accordion-type-2 .card')
            if(action.key !=undefined && action.key !="" && action.flag == undefined){
                if (action.value.currentTarget.parentNode.classList.contains("active") == true && const_var.isActiveSlide) {
                    action.value.currentTarget.parentNode.classList.remove('active');
                    controls.isCheckActiveTab = null
                    newCont =  controls.isCheckActiveTab
                } else {
                    sections = action.value.currentTarget.parentNode.parentNode.children;
                    for (let i = 0; i < sections.length; i++) {
                        sections[i].classList.contains("active")
                        sections[i].classList.remove('active');
                    }
                    controls.isCheckActiveTab = action.key
                    action.value.currentTarget.parentNode.classList.add('active')
                    newCont =  controls.isCheckActiveTab

                }
            }else{
                controls.isCheckActiveTab = null
                newCont =  controls.isCheckActiveTab

            }
            if(action.flag == "change" &&  document.getElementsByClassName('card-menu')!=undefined){
                controls.isCheckActiveTab = action.key
                newCont =  controls.isCheckActiveTab
                document.getElementsByClassName('card-menu')[1]?.classList.remove('active')
                document.getElementsByClassName('card-menu')[0]?.classList.add('active')
            }
            if(action.flag == "reset" &&  document.getElementsByClassName('card-menu')!=undefined){
                controls.isCheckActiveTab = action.key
                newCont =  controls.isCheckActiveTab
                let cardArr = document.getElementsByClassName('card-menu')
                for(let i = 0 ; i<=cardArr.length-1; i++){
                    cardArr[i].classList.remove('active')
                }
                const_var.activeTab = "buildingtypetab"
                document.getElementsByClassName('card-menu')[0]?.classList.add('active')
                document.getElementsByClassName('card-menu')[0].scrollIntoView(0,0)
            }
            if(action.flag == "statechange" &&  document.getElementsByClassName('card-menu')!=undefined){
                controls.isCheckActiveTab = "buildsizes"
                newCont =  controls.isCheckActiveTab
                let cardArr = document.getElementsByClassName('card-menu')
                for(let i = 0 ; i<=cardArr.length-1; i++){
                    cardArr[i].classList.remove('active')
                }
                document.getElementsByClassName('card-menu')[1]?.classList.add('active')
            }
            if (const_var.controls !== undefined) {
                 const_var.controls.target?.set(0, params.p_h / 2, 0);
             }
            return {
                ...state,
                newCont
            } 
        case "handleGalleyShow":
            state.showGallery = action.value  
            return {
                ...state
            } 
        case "handleTabsClick":            
            controls.isCheckActiveTab = action.key;
            const_var.activemaintabkey =  action.key;
            if(controls.isCheckActiveTab == "doorwindow"){
                const_var.wallSectionTab = "Center Building"
                params.activeWall = "c_b_f_w"
                if(params.is_translusant) {
                    params.is_translusant = false
                }
            }
            return {
                ...state,action
            }
            break;
      }
    return newState;
  };

export default eventReducer;